<template>
  <div>
    <div class="d-flex justify-content-end pdt-4 pdb-4 mgr--12">
      <input
          :id="numberValue"
          :accept="allowExt()"
          class="d-none"
          type="file"
          @change="uploadFile"
      />
      <button class="material-icons mdc-icon-button t-color-iconInactive" tabindex="0" @click="toggleDocument" @keypress="toggleDocument">
        <img
            :src="documentshow || form.comment ? '/images/checklist/file-document-edit-active.svg' : '/images/checklist/file-document-edit.svg'"
            alt="">
      </button>

      <input
          :id="'commentFileUpload'+numberValue"
          :accept="allowExt()"
          class="d-none"
          type="file"
          @change="uploadFile"
      />
      <button :class="form.image && form.image.resourceUri ? ' t-color-iconActive' : ' t-color-iconInactive'"
              class="material-icons mdc-icon-button"
              tabindex="0" @click="openFileUpload('commentFileUpload'+numberValue)" @keypress="openFileUpload('commentFileUpload'+numberValue)">collections
      </button>
    </div>
    <div v-if="documentshow || form.comment" class="pdt-4">
      <div class="">
        <div class="bg-documentGray pda-24 mgb-12 b-radius4 ">
          <div class="d-flex justify-content-between align-items-center">
            <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
            <button class="material-icons mdc-icon-button t-color-iconInactive mgr--12" tabindex="0"
                    @click="toggleDocument" @keypress="toggleDocument"><img alt="" class="w-20 h-20" src="/images/checklist/bin.svg"></button>
          </div>

          <label
              :class="numberValue"
              class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea mdc-text-field--with-internal-counter customize-textfield--outlined checklist-input"
              data-mdc-auto-init="MDCTextField">
                        <span class="mdc-notched-outline">
                          <span class="mdc-notched-outline__leading"></span>
                          <span class="mdc-notched-outline__notch">
                            <span class="mdc-floating-label t-color-textfieldActive">{{ $t('3369') }}</span>
                          </span>
                          <span class="mdc-notched-outline__trailing"></span>
                        </span>
            <span class="mdc-text-field__resizer">
						<textarea
                v-model="form.comment"
                aria-labelledby="my-label-id"
                class="mdc-text-field__input t-body3 t-line-h-22 font-r" maxlength="400" rows="4">
						</textarea>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div v-if="form.image && form.image.resourceUri" class="">
      <div class="">
        <div class="bg-documentGray pda-24 mgb-12 b-radius4">
          <div class="d-flex justify-content-between align-items-center">
            <div class="t-body3 font-r l-spacing42">{{ $t('3370') }}</div>
            <button class="material-icons mdc-icon-button t-color-iconInactive mgr--12 visibility-h"><img
                alt="" class="w-20 h-20" src="/images/checklist/bin.svg"></button>
          </div>

          <div
              class="imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive position-relative">
            <img v-if="getType(form.image.contentType) === 'image'" :src="form.image.resourceUri" alt="" class="chcklist-ans-image">
            <video-player v-else :image="form.image" :imgHeight="104" :imgWidth="104"></video-player>
            <span class="remove-img remove-edm-image position-absolute t-color-white"><i
                class="material-icons t-body1" tabindex="0" @click="removeImage" @keypress="removeImage">close</i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChecklistPhotoAlbum",

  props: ['numberValue', 'documentshow', 'form'],

  components: {
    'video-player': () => import('@/components/common/VideoPlayer')
  },

  methods: {
    allowExt() {
      return "image/jpeg, image/jpg, image/png, image/gif, video/mp4, video/mp4v, video/mpg4, video/m4v, video/quicktime, video/avi, video/wmv, video/mkv, video/mk3d, video/mks, video/webm";
    },

    uploadFile(evt) {
      this.$emit('uploadFile', evt);
    },

    toggleDocument() {
      this.$emit('toggleDocument');
    },

    removeImage() {
      this.$emit('removeImage')
    },

    getType(contentType) {
      if (contentType) {
        return contentType.split("/")[0];
      }
    },

    /**
     * 아이디 선택자 클릭 메소드
     * @param {String} status 선택자 아이디 엘레먼트
     */
    openFileUpload(status) {
      document.getElementById(status).click();
    },
  }
}
</script>

<style scoped>

</style>
